import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber } from 'antd'
import { checkDisbledInput, setSummaryTotal, checkStatus } from '../../../../utils/hospital'
import { numberWithCommas } from '../../../../utils/number'
import { changeFormatdate, changeFormatFulldate } from '../../../../utils/formatdate'
import moment from 'moment'

const { Text, Title } = Typography

class TableSummary extends Component {
	state = {
		columnsSummary: [
            {
                title: 'เล่ม',
                dataIndex: 'slipNo',
                width:'100px',
				align:'center',
                vertical:'top',
               
            },
            {
                title: 'เลขที่ใบเสร็จ',
                dataIndex: 'numberSlip',
                vertical:'top',
				align:'center',
                width:'100px',
               
            },
			{
                title: 'วันที่ใบเสร็จ',
                dataIndex: 'date',
				align:'center',
                vertical:'top',
                width:'190px',
            },
			{
                title: 'จำนวนเงินในใบเสร็จ',
				align:'center',
                width:'150px',
                vertical:'top',
                dataIndex: 'totalPrice',
                render: (item, record, index) => {
                    return(
                        <>
                           <Input 
                                className='block-news mt-2 input-number'
                                defaultValue={this.state.summaryTotalTable ? numberWithCommas(this.state.summaryTotalTable) : ''} 
                                value={this.state.summaryTotalTable ? numberWithCommas(this.state.summaryTotalTable) : ''} 
                                disabled={true}
                            />
                        </>
                       
                    )
                }
            },
            {
                title: 'จำนวนเงินที่เบิกได้',
				align:'center',
                width:'150px',
                vertical:'top',
                dataIndex: 'totalPrice',
                render: (item, record, index) => {
                    return(
                        <>
                           <Input 
                                className='block-news mt-2 input-number'
                                defaultValue={this.state.summaryTotalSlipWithdraw ? numberWithCommas(this.state.summaryTotalSlipWithdraw) : ''} 
                                value={this.state.summaryTotalSlipWithdraw ? numberWithCommas(this.state.summaryTotalSlipWithdraw) : ''} 
                                disabled={true}
                            />
                        </>
                       
                    )
                }
            },
            {
                title: 'เอกสารแนบ',
                dataIndex: '7',
                width:'200px',
                vertical:'top',
				align:'center',
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                width:'20px',
                vertical:'top',
				align:'center',
                fixed:'right',
            },
        ],
        summaryTotalTable: 0,
        summaryTotalSlipWithdraw: 0
	}

    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };

    async componentDidUpdate(prevProps, prevState, snapshot){
		const { summaryTotalTable, summaryTotalSlipWithdraw } = this.props

        if(prevProps.summaryTotalTable !== summaryTotalTable){
            await this.setState({
                summaryTotalTable
            })
        }

        if(prevProps.summaryTotalSlipWithdraw !== summaryTotalSlipWithdraw){
            await this.setState({
                summaryTotalSlipWithdraw
            })
        }
	}


	async componentDidMount() {
		const { summaryTotalTable, summaryTotalSlipWithdraw } = this.props

        await this.setState({
            summaryTotalTable,
            summaryTotalSlipWithdraw
        })
	}

	render() {
		const { columnsSummary } = this.state

        return (
                <>
                    <Table
                        dataSource={[{totalPrice:null}]}
                        columns={columnsSummary}
                        pagination={false}
                        className="mb-3 tableCutomSummary"
                        bordered
                        scroll={{ x:"max-content"}}
                    />
                </>
		)
	}
}

TableSummary.defaultProps = {
	autoFocus: false
}

TableSummary.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedTableSummary = Form.create()(TableSummary)

export default withApollo(WrappedTableSummary)